import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=0ca5ba93&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=0ca5ba93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5ba93",
  null
  
)

export default component.exports